/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, OnInit } from '@angular/core';
import { HttpCacheService, Logger } from '@app/core';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { ApiQuery } from '@app/core/http/api-query';
import { TypesService } from '@app/settings/types/types.service';
import { TypesFormService } from '@app/settings/types/types-form.service';
import { Type } from '@app/settings/types/types.model';
import { KendoGridComponent } from '@app/shared/kendo/kendo-grid.component';
import { KendoGridService } from '@app/shared/kendo/kendo-grid.service';
import { environment } from '@env/environment';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';
import { UserRoleType } from '@app/settings/users/user-role-type.enum';
import { AccessService } from '@app/core/access/access.service';

const log = new Logger('typesListComponent');

@Component({
  selector: 'app-types-list',
  templateUrl: './types-list.component.html',
  styleUrls: ['./types-list.component.scss'],
})
export class TypesListComponent extends KendoGridComponent implements OnInit {
  typesResponse: PaginatedResponse;
  data: GridDataResult;
  state: DataStateChangeEvent;
  apiQuery: ApiQuery = new ApiQuery();
  env = environment;

  UserRoleType = UserRoleType;

  constructor(
    private typesService: TypesService,
    private typesFormService: TypesFormService,
    protected kendoGridService: KendoGridService,
    private httpCacheService: HttpCacheService,
    public accessService: AccessService
  ) {
    super(kendoGridService);
  }

  ngOnInit() {
    this.state = CustomKendoFilter.getStateFromStorage('TypesListComponent');
    this.loadData(this.state);
  }

  /*
   * Load data from API
   * */
  loadData(state: DataStateChangeEvent = null) {
    this.state = state;
    this.apiQuery.setDataSetFilters(state);
    log.debug(this.typesService);

    this.typesService.index(this.apiQuery).subscribe((response: PaginatedResponse) => {
      this.typesResponse = response;
      this.data = response.getGridData();
    });

    CustomKendoFilter.pushStateInStorage('TypesListComponent', this.state);
  }

  /*
   * Add type - open modal
   * */
  add() {
    this.typesFormService.open().then(
      (response) => {
        this.httpCacheService.cleanCache();
        this.loadData();
      },
      (err) => {
        log.info('modal closed');
      }
    );
  }

  /**
   * Edit type - open modal
   * @param type object
   */
  edit(type: Type) {
    this.typesFormService.open(type).then(() => {
      this.httpCacheService.cleanCache();
    });
  }

  /**
   * Delete type
   * @param type object
   */
  delete(type: Type) {
    this.typesService.destroy(type.id).subscribe(() => {
      this.httpCacheService.cleanCache();
      this.loadData(this.state);
    });
  }

  clearFilters() {
    this.apiQuery = new ApiQuery();
    this.loadData();
  }
}
